import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { getZones } from "../../../MyApi/zones";
import LoadingSpinner from "../../../Components/UI/spinner";
import { getVehicles } from "../../../MyApi/vehicles";
import HeaderBar from "../../../Components/UI/headerbar";
import {
  showShippingPricing,
  storeShippingMethods,
  updateShippingPrices,
} from "../../../MyApi/shippingprice";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../../Components/UI/buttonGlobal";
import i18next from "i18next";
import { formatPrice } from "../../../utils/formatPrice";
import { shippingPricingSchema } from "./schema";
import DeleteIcon from "../../../Components/Common/svg/deleteicon";

const ShippingPricingStore = ({ mode, id }) => {
  const location = useLocation();
  const [prices, setPrices] = useState([]);
  const [zone_id, setZoneId] = useState("");
  const [selectedLangCode, setSelectedLangCode] = useState("");

  const [validationErrors, setValidationErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const lang = i18next.language;
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationKey: ["postShippingStore"],
    mutationFn: (postData) => storeShippingMethods(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      navigate(`${process.env.PUBLIC_URL}/area-pricing`);
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const { data: shippingPriceData, isLoading: isLoadingShippingPrice } =
    useQuery(["showShippingPricing", id ,selectedLangCode], () => showShippingPricing(id ,selectedLangCode), {
      enabled: mode === "edit",
    });

const ShippingPrice = shippingPriceData?.data?.ShippingPrices || [];
const currencyFactor = ShippingPrice[0]?.currency_factor || 100;
  const mutationUpdate = useMutation({
    mutationKey: ["updateShippingPrices"],
    mutationFn: (postData) => updateShippingPrices(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      navigate(`${process.env.PUBLIC_URL}/area-pricing`);
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const { data, isLoading } = useQuery("getZones", getZones);
  const { data: vehiclesData, isLoading: isVehicleLoading } = useQuery(
    "getVehicles",
    getVehicles,
  );

  const zones = data?.data?.zones || [];
  const vehicles = vehiclesData?.data?.vehicles || [];

  useEffect(() => {
    setSelectedLangCode(lang);
  }, []);

  // useEffect(() => {
  //   if (vehicles.length > 0 && mode === "edit" && ShippingPrices.length > 0) {
  //     setPrices(() => [
  //       {
  //         vehicle_id: ShippingPrice?.vehicle_id,
  //         name:ShippingPrice?.name,
  //         base_price: formatPrice(currencyFactor, ShippingPrice.base_price),
  //         max_price: formatPrice(currencyFactor, ShippingPrice.max_price),
  //         per_km_price: formatPrice(currencyFactor, ShippingPrice.per_km_price),
  //         max_cod_price: formatPrice(
  //           currencyFactor,
  //           ShippingPrice.max_cod_price,
  //         ),
  //         per_km_price_for_package: formatPrice(
  //           currencyFactor,
  //           ShippingPrice.per_km_price_for_package,
  //         ),
  //         base_price_for_package: formatPrice(
  //           currencyFactor,
  //           ShippingPrice.base_price_for_package,
  //         ),
  //         enable_cod: ShippingPrice?.enable_cod,
  //         is_active: ShippingPrice?.is_active,
  //       },
  //     ]);
  //     setCurrencyFactor(ShippingPrice?.currency_factor);
  //     setZoneId(ShippingPrice?.zone_id);
  //   }
  // }, [ShippingPrice, vehicles, zones, currencyFactor]);

  useEffect(() => {
  if (vehicles.length > 0 && mode === "edit" && ShippingPrice.length > 0) {
    // Map shipping prices to vehicles structure
    const mappedPrices = ShippingPrice.map(sp => {
      const vehicle  = vehicles.find(v => sp.vehicle_id === v.id);

      if (vehicle) {
        return {
          vehicle_id: vehicle?.id,
          name: sp?.name,
          base_price: formatPrice(sp.currency_factor, sp.base_price),
          max_price: formatPrice(sp.currency_factor, sp.max_price),
          per_km_price: formatPrice(sp.currency_factor, sp.per_km_price),
          max_cod_price: formatPrice(sp.currency_factor, sp.max_cod_price),
          per_km_price_for_package: formatPrice(sp.currency_factor, sp.per_km_price_for_package),
          base_price_for_package: formatPrice(sp.currency_factor, sp.base_price_for_package),
          enable_cod: sp.enable_cod,
          is_active: sp.is_active,
        };
      }
    });

    setPrices(mappedPrices);
    
    setZoneId(ShippingPrice[0]?.zone_id || "");
  }
}, [ShippingPrice, vehicles]);
console.log('prices', prices)
  useEffect(() => {
    if (vehicles.length > 0 && mode !== "edit") {
      setPrices(
        vehicles.map((v) => ({
          vehicle_id: v.id,
          base_price: 0,
          max_price: 0,
          per_km_price: 0,
          max_cod_price: 0,
          per_km_price_for_package: 0,
          base_price_for_package: 0,
          enable_cod: false,
        })),
      );
    }
  }, [vehicles]);

  const handleChange = (vehicle_id, field, value) => {
    if (validationErrors.vehicles) {
      const updatedErrors = { ...validationErrors };
      if (updatedErrors.vehicles._errors) {
        updatedErrors.vehicles._errors = updatedErrors.vehicles._errors.filter(
          (error) => !error.includes(field),
        );
      }
      setValidationErrors(updatedErrors);
    }

    setPrices((prev) =>
      prev.map((item) =>
        item.vehicle_id === vehicle_id ? { ...item, [field]: value } : item,
      ),
    );
  };
  const handleZoneChange = (e) => {
    const { value } = e.target;
    console.log("zone_id", value);
    setZoneId(value);
  };
  const handleSubmit = async () => {
    const formData = {
      zone_id,
      vehicles: prices,
      lang: selectedLangCode,
    };

    const result = shippingPricingSchema.safeParse(formData);

    
    if (!result.success) {
      // Extract and set validation errors
      console.log("result.error.issues", result.error.format());
      setValidationErrors(result.error.format());
      return;
    }

    // Clear any existing validation errors
    setValidationErrors({});
    setIsSubmitting(true);

    try {
      if (mode === "edit") {
        await mutationUpdate.mutateAsync({
          zone_id,
          vehicles: prices,
          _method: "PUT",
          lang: selectedLangCode,
        });
      } else {
        await mutation.mutateAsync({
          zone_id,
          vehicles: prices,
          lang: selectedLangCode,
        });
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };
 console.log('prices', prices)

 

const handleAddRestVehicles =()=>{
   const restVehiclesArr = vehicles.filter((vehicle)=> !prices.some((price)=> vehicle?.id === price?.vehicle_id )) ||[]
  if(restVehiclesArr.length >0){
       const newVehicles = restVehiclesArr.map((v) => ({
      vehicle_id: v.id,
      base_price: 0,
      max_price: 0,
      per_km_price: 0,
      max_cod_price: 0,
      per_km_price_for_package: 0,
      base_price_for_package: 0,
      enable_cod: false,
      is_active:1
    }));

   setPrices((prev)=>[...prev , ...newVehicles])
  }else{
    toast.error("لاتوجد مركبات إضافبة")
  }
}

const handleDeleteRoW =(id)=>{
const updatedPricesArr = prices.filter((price)=>price.vehicle_id !== id)
console.log('updatedPricesArr', updatedPricesArr)
setPrices(updatedPricesArr)
}

  if (isLoading || isLoadingShippingPrice) return <LoadingSpinner />;

  return (
    <>
      <HeaderBar
        title={
          mode === "edit" ? "تعديل تسعيرة المنطقة" : "إضافة تسعيرة المنطقة"
        }
        content={
          mode === "edit"
            ? "تعديل بيانات تسعيرة المنطقة"
            : "أدخل بيانات تسعيرة المنطقة"
        }
        isBack={true}
        isEdit={mode === "edit"}
        setSelectedLangCode={setSelectedLangCode}
        
      />
      <div className="container">
        <div className="card rounded-4 table-loader">
          <div className="card-body">
            {/* Select Zone */}
            <div className="row mb-4 add">
              <div className="col-12">
                <label className="form-label">المنطقة</label>
                <select
                  name="zone_id"
                  id="zone_id"
                  value={zone_id}
                  className={`form-select ${validationErrors.zone_id ? "is-invalid" : ""}`}
                  onChange={handleZoneChange}
                >
                  <option>اختار منطقة</option>
                  {zones.map((zone) => (
                    <option key={zone.id} value={zone.id}>
                      {zone.name}
                    </option>
                  ))}
                </select>
                {validationErrors.zone_id && (
                  <div className="invalid-feedback">
                    {validationErrors.zone_id._errors[0]}
                  </div>
                )}
              </div>
            </div>

            {isVehicleLoading ? (
              <LoadingSpinner />
            ) : (
              prices.map((vehicleInput, vehicleIndex) => {
                const vehicle =  vehicles.find((v)=>v.id === vehicleInput?.vehicle_id)

                // Helper function to get error for a specific field
                const getFieldError = (fieldName) => {
                  return (
                    validationErrors?.vehicles?.[vehicleIndex]?.[fieldName]
                      ?._errors?.[0] || null
                  );
                };

                return (
                  <div className="row mb-3 add" key={vehicleInput?.vehicle_id}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                       <div className="d-flex align-items-center gap-3">  <h6>{vehicle?.name}</h6>  {prices.length !== 1&& <button className="btn"  onClick={()=>handleDeleteRoW(vehicleInput.vehicle_id)}><DeleteIcon /></button>  }  </div> 
                   {(mode==="edit" && vehicleIndex ===0)&&<button className="btn btn-primary" onClick={handleAddRestVehicles}>إضافة مركبات جديدة</button>}
                      <div className="d-flex align-items-center gap-1">
                        <label htmlFor="" className="form-label">
                          الدفع كاش
                        </label>
                        <label class="switch">
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              handleChange(
                                vehicleInput?.vehicle_id,
                                "enable_cod",
                                e.target.checked,
                              )
                            }
                            checked={vehicleInput?.enable_cod}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                           <div className="d-flex align-items-center gap-1">
                        <label htmlFor="" className="form-label">
                      نشط
                        </label>
                        <label class="switch">
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              handleChange(
                                vehicleInput.vehicle_id,
                                "is_active",
                                e.target.checked ?1 :0,
                              )
                            }
                            checked={vehicleInput?.is_active ===1}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                   

                    <div className="col-md mt-2">
                      <label className="form-label">سعر البداية</label>
                      <input
                        type="number"
                        min={0}
                        className={`form-control ${getFieldError("base_price") ? "is-invalid" : ""}`}
                        value={vehicleInput?.base_price}
                        onChange={(e) =>
                          handleChange(
                            vehicleInput?.vehicle_id,
                            "base_price",
                            e.target.value,
                          )
                        }
                      />
                      {getFieldError("base_price") && (
                        <div className="invalid-feedback">
                          {getFieldError("base_price")}
                        </div>
                      )}
                    </div>

                    <div className="col-md mt-2">
                      <label className="form-label">أقصي سعر</label>
                      <input
                        type="number"
                        min={0}
                        className={`form-control ${getFieldError("max_price") ? "is-invalid" : ""}`}
                        value={vehicleInput?.max_price}
                        onChange={(e) =>
                          handleChange(
                            vehicleInput?.vehicle_id,
                            "max_price",
                            e.target.value,
                          )
                        }
                      />
                      {getFieldError("max_price") && (
                        <div className="invalid-feedback">
                          {getFieldError("max_price")}
                        </div>
                      )}
                    </div>
                    <div className="col-md mt-2">
                      <label className="form-label">سعر كل كم</label>
                      <input
                        type="number"
                        min={0}
                        className={`form-control ${getFieldError("per_km_price") ? "is-invalid" : ""}`}
                        value={vehicleInput?.per_km_price}
                        onChange={(e) =>
                          handleChange(
                            vehicleInput?.vehicle_id,
                            "per_km_price",
                            e.target.value,
                          )
                        }
                      />
                      {getFieldError("per_km_price") && (
                        <div className="invalid-feedback">
                          {getFieldError("per_km_price")}
                        </div>
                      )}
                    </div>
                    <div className="col-md   mt-2">
                      <label className="form-label"> أقصي سعر استلام كاش</label>
                      <input
                        type="number"
                        min={0}
                        className={`form-control ${getFieldError("max_cod_price") ? "is-invalid" : ""}`}
                        value={vehicleInput?.max_cod_price}
                        onChange={(e) =>
                          handleChange(
                            vehicleInput?.vehicle_id,
                            "max_cod_price",
                            e.target.value,
                          )
                        }
                      />
                      {getFieldError("max_cod_price") && (
                        <div className="invalid-feedback">
                          {getFieldError("max_cod_price")}
                        </div>
                      )}
                    </div>
                    <div className="col-md   mt-2">
                      <label className="form-label"> السعر الرئيسي</label>
                      <input
                        type="number"
                        min={0}
                        className={`form-control ${getFieldError("base_price_for_package") ? "is-invalid" : ""}`}
                        value={vehicleInput?.base_price_for_package}
                        onChange={(e) =>
                          handleChange(
                            vehicleInput?.vehicle_id,
                            "base_price_for_package",
                            e.target.value,
                          )
                        }
                      />
                      {getFieldError("base_price_for_package") && (
                        <div className="invalid-feedback">
                          {getFieldError("base_price_for_package")}
                        </div>
                      )}
                    </div>

                    <div className="col-md   mt-2">
                      <label className="form-label">
                        {" "}
                        السعر لكل كم لخدمة اطلب ووصل
                      </label>
                      <input
                        type="number"
                        min={0}
                        className={`form-control ${getFieldError("per_km_price_for_package") ? "is-invalid" : ""}`}
                        value={vehicleInput?.per_km_price_for_package}
                        onChange={(e) =>
                          handleChange(
                            vehicleInput?.vehicle_id,
                            "per_km_price_for_package",
                            e.target.value,
                          )
                        }
                      />
                      {getFieldError("per_km_price_for_package") && (
                        <div className="d-block invalid-feedback">
                          {getFieldError("per_km_price_for_package")}
                        </div>
                      )}
                    </div>
               
                
                  </div>
                );
              })
            )}
            <div className="d-flex gap-3">
              <Button
                onClick={handleSubmit}
                className={"btn-primary rounded-3"}
                isLoading={
                  isSubmitting || mutation.isLoading || mutationUpdate.isLoading
                }
                disabled={
                  isSubmitting || mutation.isLoading || mutationUpdate.isLoading
                }
                label={
                  mode === "edit"
                    ? " تأكيد تعديل تسعيرة المنطقة"
                    : " تأكيد إضافة تسعيرة المنطقة"
                }
              >
                {" "}
              </Button>

              <button className="btn btn-white" onClick={() => navigate(-1)}>
                إلغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingPricingStore;
